import script from "./products_list.vue?vue&type=script&setup=true&lang=js"
export * from "./products_list.vue?vue&type=script&setup=true&lang=js"

import "./products_list.vue?vue&type=style&index=0&id=4049919e&scoped=true&lang=css"

import exportComponent from "/var/www/html/obelle-form-order/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4049919e"]])

export default __exports__